// Loaders
import { BaseWorkerLoader } from "../../base/loaders/BaseWorkerLoader";
/**
 * Loader class for loading workers in the web app
 */
export class WebWorkerLoader extends BaseWorkerLoader {
}
